import React, { useState } from 'react'
import clsx from 'clsx'
import useResponsive from 'utils/useResponsive'
import { MapDesktop, MapMobile } from 'parts/Maps'

const regions = [
  { id: 1, name: 'Jabodetabek' },
  { id: 2, name: 'Jawa Barat' },
  { id: 3, name: 'Jawa Tengah' },
  { id: 4, name: 'Jawa Timur' }
]

const Maps = () => {
  const [selectedRegion, setSelectedRegion] = useState(1)

  const isXs = Object.values(useResponsive()).find((el) => el)

  return (
    <section
      id="map"
      className="pt-10 pb-10 md:py-[96px] lg:py-20 xl:py-[124px] px-6 lg:px-14 xl:px-[120px] m-auto left-0 right-0 bg-[#F4633A] lg:py-20 xl:py-[88px]"
    >
      <h1 className="h4-bold xl:h3-bold text-center max-w-[773px] sm:w-full m-auto left-0 right-0 relative text-white">
        <Pattern />
        Temukan Manuva Retail di Daerahmu
      </h1>
      <div className="flex w-fit max-w-full flex-nowrap overflow-auto items-center m-auto mt-[40px] rounded-[40px] bg-[#fff]/[0.08] mb-[33px] md:mb-[96px]">
        {regions.map(({ id, name }) => (
          <div
            key={id}
            onClick={() => setSelectedRegion(id)}
            className={clsx(
              'cursor-pointer lg:w-fit rounded-[40px] px-[16px] py-3.5 lg:px-7 text-base lg:text-lg font-normal leading-[150%]',
              selectedRegion === id
                ? 'text-white bg-white text-[#F4633A] font-medium'
                : 'text-white hover:bg-[#fff]/[0.5] hover:text-white'
            )}
          >
            <div className="flex items-center gap-x-[10px] whitespace-nowrap">
              {name}
            </div>
          </div>
        ))}
      </div>
      <div className="">
        {/* eslint-disable-next-line multiline-ternary */}
        {isXs ? (
          <MapDesktop
            selectedRegion={selectedRegion}
            setSelectedRegion={setSelectedRegion}
          />
        ) : (
          <MapMobile
            selectedRegion={selectedRegion}
            setSelectedRegion={setSelectedRegion}
          />
        )}
      </div>
    </section>
  )
}

const Pattern = () => (
  <svg
    className="absolute top-[50%] translate-y-[-50%] left-[-20px]"
    width="135"
    height="89"
    viewBox="0 0 135 89"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.716 88.9342C23.9379 83.8298 36.8047 30.4982 78.756 21.387V0.438477C60.5389 3.14622 36.675 14.1236 23.586 33.4621L22.6049 34.9257L22.716 13.7211H0V88.8611L22.716 88.9342Z"
      fill="white"
      fillOpacity="0.12"
    />
    <path
      d="M135 0.438477V21.387C93.0486 30.5347 80.1633 83.8298 78.9599 88.9342H56.1514V40.4876C65.7783 31.1385 75.4423 28.2112 78.8488 28.138V34.9074L79.83 33.4621C92.9004 14.1236 116.857 3.14622 135 0.438477"
      fill="white"
      fillOpacity="0.12"
    />
    <path
      d="M134.999 28.1375V88.9337H112.302V40.487C121.91 31.1379 131.593 28.2106 134.999 28.1375Z"
      fill="white"
      fillOpacity="0.12"
    />
  </svg>
)

export default Maps
